import { render } from "./BurgerPannel.vue?vue&type=template&id=22955560&scoped=true"
import script from "./BurgerPannel.vue?vue&type=script&lang=js"
export * from "./BurgerPannel.vue?vue&type=script&lang=js"

import "./BurgerPannel.vue?vue&type=style&index=0&id=22955560&lang=stylus&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22955560"]])

export default __exports__